import React from "react";
import { TIPTAP_DIVIDER_TYPE } from "./../ricos-content/index.js";
import { DividerData_Alignment, DividerData_Width } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { PLUGIN_TOOLBAR_ALIGNMENT_BUTTON } from "./../_shared/data-hooks.js";
import { getNodeInSelection } from "./../_shared/resolvers/get-node-in-selection.js";
import { isVisibleOnlyOnDesktop } from "./../_shared/resolvers/is-visible-only-on-desktop.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import { DIVIDER_BUTTONS, DIVIDER_SIZE_RESOLVER_ID, DIVIDER_STYLE_RESOLVER_ID } from "./const.js";
import {
  PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON,
  PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON
} from "./data-hooks.js";
import { DividerAlignmentButton } from "./toolbar/buttons/DividerAlignmentButton.js";
import { DividerSizeButton } from "./toolbar/buttons/DividerSizeButton.js";
import { DividerStyleButton } from "./toolbar/buttons/DividerStyleButton.js";
const resolveDividerAttribute = ({
  resolverId,
  attribute
}) => {
  return {
    id: resolverId,
    resolve: (content) => {
      if (Array.isArray(content) && content.length > 0) {
        return content.find((node) => node.type.name === TIPTAP_DIVIDER_TYPE)?.attrs?.[attribute];
      } else {
        return void 0;
      }
    }
  };
};
const getToolbarButtons = (_config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: DIVIDER_BUTTONS.style,
      dataHook: PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON,
      command: ({ value, tiptapEditor }) => {
        tiptapEditor.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, {
          lineStyle: value
        }).run();
      },
      attributes: {
        nodeStyle: resolveDividerAttribute({
          resolverId: DIVIDER_STYLE_RESOLVER_ID,
          attribute: "lineStyle"
        })
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerStyleButton, { toolbarItem, id: DIVIDER_BUTTONS.style })
    },
    {
      id: DIVIDER_BUTTONS.size,
      dataHook: PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON,
      command: ({ value, tiptapEditor, attributes: { selectedNode } }) => {
        const nodeContainerData = selectedNode.attrs?.containerData;
        const isFullWidth = value === DividerData_Width.LARGE;
        const newAttributes = isFullWidth ? {
          width: value,
          alignment: DividerData_Alignment.CENTER,
          containerData: { ...nodeContainerData, alignment: DividerData_Alignment.CENTER }
        } : { width: value };
        tiptapEditor.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, newAttributes).run();
      },
      attributes: {
        nodeSize: resolveDividerAttribute({
          resolverId: DIVIDER_SIZE_RESOLVER_ID,
          attribute: "width"
        }),
        selectedNode: getNodeInSelection,
        visible: isVisibleOnlyOnDesktop(isMobile)
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerSizeButton, { toolbarItem })
    },
    {
      id: DIVIDER_BUTTONS.alignment,
      dataHook: PLUGIN_TOOLBAR_ALIGNMENT_BUTTON,
      command: ({ value, tiptapEditor, attributes: { selectedNode } }) => {
        const nodeContainerData = selectedNode.attrs?.containerData;
        tiptapEditor.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, {
          alignment: value,
          containerData: { ...nodeContainerData, alignment: value }
        }).run();
      },
      attributes: {
        selectedNode: getNodeInSelection,
        visible: isVisibleOnlyOnDesktop(isMobile)
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DividerAlignmentButton, { id: DIVIDER_BUTTONS.alignment, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
